module.exports = __webpack_public_path__ + "img/logo-americaidiomas.30ad1152.png";